module.exports = __webpack_public_path__ + "img/over_the_counter.98714cbe.svg";